var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},_vm._l((_vm.menuGroups),function(group){return _c('section',{key:_vm.contentFor(group.title),staticClass:"menu-group"},[_c('h1',[_vm._v(_vm._s(_vm.contentFor(group.title)))]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.contentAsHtml(group.text))}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }